<div class="page-action-container mb-10">
  <ng-container *ngTemplateOutlet="containerArea"></ng-container>
</div>
<div *ngIf="isShowRemarkRecords" class="p-grid mb-20">
  <div class="p-col">
    <ng-container *ngTemplateOutlet="remarkRecordList"></ng-container>
  </div>
  <div *ngIf="!readonly" class="p-col">
    <ng-container *ngTemplateOutlet="processingRecordInput"></ng-container>
  </div>
</div>
<sigv-bottom-panel
  [threshold]="230"
  [styleClass]="isMenuVisible ? 'offset-for-sidemenu' : ''"
>
  <div class="cfc-split-panel" [ngClass]="{ hide: !isShowRemarkRecords }">
    <div class="pr-10">
      <ng-container *ngTemplateOutlet="remarkRecordList"></ng-container>
    </div>
    <div *ngIf="!readonly" class="pl-10">
      <ng-container *ngTemplateOutlet="processingRecordInput"></ng-container>
    </div>
  </div>
  <div class="p-text-center pv-15 cfc-wrapper-bg-gray">
    <ng-container *ngTemplateOutlet="containerArea"></ng-container>
  </div>
</sigv-bottom-panel>
<p-dialog
  [(visible)]="isShowRemarkRecordDialog"
  [modal]="true"
  [draggable]="false"
  closeIcon="pi pi-close"
  styleClass="p-dialog-lg"
  appendTo="body"
>
  <ng-template pTemplate="header">
    <h1>
      {{ 'Remark Records' | translate }}
      <span class="p-text-primary ml-10">{{ remarkRecords.length }}</span>
    </h1>
  </ng-template>
  <div class="cfc-list cfc-max-height-560">
    <ul class="cfc-list-wrapper p-white-space-pre-line">
      <li class="cfc-list-item" *ngFor="let record of remarkRecords">
        <ng-container *ngIf="remarkTemplate">
          <ng-container
            *ngTemplateOutlet="remarkTemplate; context: { $implicit: record }"
          ></ng-container>
        </ng-container>
      </li>
    </ul>
  </div>
  <ng-template pTemplate="footer">
    <div class="p-text-center">
      <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-secondary p-content-button"
        (click)="toggleRemarkRecordDialog()"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<ng-template #containerArea>
  <ng-content></ng-content>
  <button
    pButton
    label="{{
      (isShowRemarkRecords ? 'Hide Remark' : 'Show Remark') | translate
    }}"
    class="p-button-outlined p-content-button"
    (click)="toggleRemarkRecord()"
  ></button>
</ng-template>

<ng-template #remarkRecordList>
  <h2 class="mv-0">
    {{ 'Remark Record' | translate
    }}<span class="p-text-primary p-ml-2">{{ remarkRecords.length }}</span>
  </h2>
  <div class="cfc-list h-100px mt-10 mb-5">
    <ul class="cfc-list-wrapper p-white-space-pre-line">
      <li class="cfc-list-item" *ngFor="let record of remarkRecords">
        <ng-container *ngIf="remarkTemplate">
          <ng-container
            *ngTemplateOutlet="remarkTemplate; context: { $implicit: record }"
          ></ng-container>
        </ng-container>
      </li>
    </ul>
  </div>
  <div class="float-right">
    <a sigvVisitedLink class="link" (click)="toggleRemarkRecordDialog()">{{
      'View All' | translate
    }}</a>
  </div>
</ng-template>

<ng-template #processingRecordInput>
  <h2 class="mv-0">{{ 'Remark' | translate }}</h2>
  <div class="p-fluid">
    <div class="p-field mt-10 mb-0">
      <textarea
        name="textarea01"
        pInputTextarea
        [attr.autoResize]="true"
        [(ngModel)]="model"
        (ngModelChange)="updateModel($event)"
        class="h-100px"
        placeholder="please write here..."
      ></textarea>
      <small class="float-right">
        <span>{{ model?.length }}</span>
        &nbsp;/&nbsp;
        <span class="p-text-primary">1000</span>
      </small>
    </div>
  </div>
</ng-template>
